<template>
  <div
      class="invoice-shared__wrapper"
      :class="{'invoice-shared__wrapper--rtl': isArabicInvoice}"
      :dir="isArabicInvoice ? 'rtl' : 'ltr'"
      :lang="invoiceLocale">
    <a-t-loader v-if="isInvoice" />

    <template v-else>
      <div class="main-content">
        <div class="container-lg">
          <div class="invoice-shared">
            <div class="invoice-shared__top">
              <div class="top__logo">
                <img v-if="currentInvoice.bank && currentInvoice.bank.contractType === 'UAE'" src="/images/invoices/invoice-logo-UAE.png" alt="" />
                <img v-else src="/images/invoices/invoice-logo-TZ.svg" alt="" />
              </div>
              <div class="top__desc-invoice">
                <div class="name">
                  <span class="invoice-name">{{ invoiceText('invoiceNumber') }}</span>
                  <span class="invoice-number invoice-shared__ltr-content">
                  {{ currentInvoice.invoiceNumber }}
                </span>
                </div>

                <div
                    class="status"
                    :class="[
                    {paid: currentInvoice.status === 'PAID'},
                    {sent: currentInvoice.status === 'SENT'},
                    {cancel: currentInvoice.status === 'CANCEL'},
                    {refund: currentInvoice.status === 'REFUND'},
                    {'partially-paid': currentInvoice.status === 'PARTIALLY'},
                  ]">
                  <span class="name">{{ invoiceText('status') }}:</span>
                  <svg v-if="currentInvoice.status === 'PARTIALLY'" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_4893_4639" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="8">
                      <rect width="8" height="8" rx="4" fill="#FFDA44"/>
                    </mask>
                    <g mask="url(#mask0_4893_4639)">
                      <rect width="8" height="8" rx="4" fill="#D7D7D7"/>
                      <rect x="-3" y="-3" width="7" height="12" fill="#77B017"/>
                    </g>
                  </svg>
                  <div class="circle"></div>
                  <span v-if="currentInvoice.status === 'PAID'" class="type"
                  >{{ invoiceText('statuses.paid') }}</span
                  >
                  <span v-if="currentInvoice.status === 'SENT'" class="type"
                  >{{ invoiceText('statuses.notPaid') }}</span
                  >
                  <span v-if="currentInvoice.status === 'CANCEL'" class="type"
                  >{{ invoiceText('statuses.cancelled') }}</span
                  >
                  <span v-if="currentInvoice.status === 'REFUND'" class="type"
                  >{{ invoiceText('statuses.refunded') }}</span
                  >
                  <span v-if="currentInvoice.status === 'PARTIALLY'" class="type"
                  >{{ invoiceText('statuses.partiallyPaid') }}</span
                  >
                </div>
              </div>
            </div>
            <div class="invoice-shared__bank">
              <div v-if="!currentInvoiceBank" class="bank-block">
                <div class="invoice-shared__alert invoice-shared__alert--noprint">
                  {{ invoiceText('bankTransferUnavailable') }}
                </div>
              </div>
              <div class="bank-block">
                <div v-if="currentInvoiceBank" class="bank-block_content">
                  <div
                      v-if="currentInvoiceBank[`paymentReminder${currentInvoice.currencyType}`]"
                      class="invoice-shared__alert invoice-shared__alert--noprint"
                      v-html="currentInvoiceBank[`paymentReminder${currentInvoice.currencyType}`]">
                  </div>
                  <div class="content-block">
                    <span class="content-block_title">{{ invoiceText('beneficiary') }}</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name" v-if="currentInvoiceBank.companyName">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('companyName') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.companyName)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name" dir="auto">{{ currentInvoiceBank.companyName }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.companyName)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name" v-if="currentInvoiceBank.ibanAccount">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('accountNumber') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.ibanAccount.split(' ').join(''))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoiceBank.ibanAccount }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.ibanAccount.split(' ').join(''))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name" v-if="currentInvoiceBank.beneficiaryAddress">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('companyAddress') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.beneficiaryAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name" dir="auto">{{ currentInvoiceBank.beneficiaryAddress }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.beneficiaryAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div v-if="currentInvoiceBank" class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">{{ invoiceText('bankOfBeneficiary') }}</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name" v-if="currentInvoiceBank.swift">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('swift') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.swift)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoiceBank.swift }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.swift)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name" v-if="currentInvoiceBank.name">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('bankName') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.name)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name" dir="auto">{{ currentInvoiceBank.name }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.name)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div class="content-block_name" v-if="currentInvoiceBank.bankAddress">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('bankAddress') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.bankAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name" dir="auto">{{ currentInvoiceBank.bankAddress }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.bankAddress)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentInvoiceBank.accountNumber" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('accountNumber') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.accountNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoiceBank.accountNumber }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.accountNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentInvoiceBank.sortCode" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('sortCode') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.sortCode)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoiceBank.sortCode }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.sortCode)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentInvoiceBank.routingNumber" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('routingNumber') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.routingNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoiceBank.routingNumber }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.routingNumber)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                    <div v-if="currentInvoiceBank.accountType" class="content-block_name">
                      <div class="content-block_name-mobile">
                        <span>{{ invoiceText('accountType') }}:</span>
                        <svg @click="copyText(currentInvoiceBank.accountType)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                        </svg>
                      </div>
                      <span class="sub-name" dir="auto">{{ currentInvoiceBank.accountType }}</span>
                      <svg class="content-block_icon-mobile" @click="copyText(currentInvoiceBank.accountType)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25 7.875V3H1.5C0.671627 3 0 3.67163 0 4.5V10.5C0 11.3284 0.671627 12 1.5 12H7.5C8.32837 12 9 11.3284 9 10.5V9.75H4.125C3.29663 9.75 2.25 8.70337 2.25 7.875ZM10.5 0H4.5C3.67163 0 3 0.671627 3 1.5V7.5C3 8.32837 3.67163 9 4.5 9H10.5C11.3284 9 12 8.32837 12 7.5V1.5C12 0.671627 11.3284 0 10.5 0Z" fill="#77B017"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">{{ invoiceText('payer') }}:</span>
                    <span class="content-block_desc" dir="auto">{{currentInvoice.payer.payerType === 'OPERATOR' ? currentInvoice.payer.operator.companyName : currentInvoice.payer.participant}}</span>
                  </div>
                  <div class="content-block" v-if="(
                      currentInvoice.payer.payerType === 'OPERATOR') &&
                      (currentInvoice.payer.operator.tin.length !== 0 || currentInvoice.payer.operator.vrn.length !== 0 || currentInvoice.payer.operator.phone.length !== 0 || currentInvoice.payer.operator.address.length !== 0)
                    ">
                    <div class="content-block_name">
                      <span>{{ invoiceText('tin') }}:</span>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoice.payer.operator.tin }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>{{ invoiceText('vrn') }}:</span>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoice.payer.operator.vrn }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>{{ invoiceText('mobile') }}:</span>
                      <span class="sub-name invoice-shared__ltr-content">{{ currentInvoice.payer.operator.phone }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>{{ invoiceText('address') }}:</span>
                      <span class="sub-name" dir="auto">{{ currentInvoice.payer.operator.address }}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="invoice-shared__payer">
              <div class="payer__services">
                <div class="payer-services-header">
                  <div class="services-header_title">
                    <span>{{ invoiceText('descriptionOfServices') }}</span>
                  </div>
                  <div class="services-header_qty">
                    <span>{{ invoiceText('quantity') }}</span>
                  </div>
                  <div class="services-header_price">
                    <span>{{ invoiceText('price') }}</span>
                  </div>
                  <div class="services-header_date">
                    <span>{{ invoiceText('dates') }}</span>
                  </div>
                  <div class="services-header_amount">
                    <span>{{ invoiceText('amount') }}</span>
                  </div>
                  <div class="services-header_amount">
                    <span>{{ invoiceText('toBePaid') }}</span>
                  </div>
                </div>
                <div
                  class="payer-services-body"
                  v-for="service in currentInvoice.services" :key="service.id">
                  <div class="body__item-description">
                    <svg v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                    >
                    <svg v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                    >
                    <svg v-if="service.type === 'AIRPORT_VIP_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                    >
                    <svg v-if="service.type === 'TRANSFER'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                    >
                    <svg v-if="service.type === 'FLIGHT'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                    >
                    <svg v-if="service.type === 'MAINLAND'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                    >
                    <svg v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                    >
                    <svg v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                    >
                    <svg v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                    >
                    <svg v-if="service.type === 'EXTRA_ACCOMMODATION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                    >
                    <span dir="auto">{{ service.name }}</span>
                  </div>
                  <div class="body__item-qty invoice-shared__ltr-content">
                    <span>{{ service.quantity }}</span>
                  </div>
                  <div class="body__item-price invoice-shared__ltr-content">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.price) }}</span>
                  </div>
                  <div class="body__item-date invoice-shared__ltr-content">
                    <span>{{ parseDateToString(service.startDate) }} </span>
                    <span>{{ parseDateToString(service.endDate) }}</span>
                  </div>
                  <div class="body__item-amount invoice-shared__ltr-content">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.amount) }}</span>
                  </div>
                  <div class="body__item-payable invoice-shared__ltr-content">
                    <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                    <span>{{ numberWithCommas(service.amountPayable) }}</span>
                  </div>
                </div>
              </div>
              <div class="payer__total-inner">
                <div class="payer__total-draft"></div>
                <div class="payer__block">
                  <div class="payer__total">
                    <div class="total-name">
                      <span>{{ invoiceText('currentDeposit') }}:</span>
                    </div>
                    <div class="total-result invoice-shared__ltr-content">
                      <template v-if="currentInvoice.currentDeposit">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                            currentInvoice.currentDeposit === null
                                ? ''
                                : numberWithCommas(currentInvoice.currentDeposit)
                          }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                  <div class="payer__total">
                    <div class="total-name">
                      <span>{{ invoiceText('totalAmount') }}:</span>
                    </div>
                    <div class="total-result invoice-shared__ltr-content">
                      <template v-if="currentInvoice.totalAmount">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                            currentInvoice.totalAmount === null
                                ? ''
                                : numberWithCommas(currentInvoice.totalAmount)
                          }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                  <div class="payer__total">
                    <div class="total-name">
                      <span>{{ invoiceText('amountPayable') }}:</span>
                    </div>
                    <div class="total-result invoice-shared__ltr-content">
                      <template v-if="currentInvoice.totalAmountPayable">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                            currentInvoice.totalAmountPayable === null
                                ? ''
                                : numberWithCommas(currentInvoice.totalAmountPayable)
                          }}</span>
                      </template>
                      <template v-else>
                        <span>0</span>
                      </template>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!--Mobile version start-->
            <div class="invoice-shared__payer-mobile">
              <div class="payer-mobile__services">
                <div class="payer-mobile__services-header">
                  <span>{{ invoiceText('descriptionOfServices') }}</span>
                </div>
                <div class="payer-mobile__services-body" v-for="service in currentInvoice.services" :key="service.id">
                  <div class="body__item-description">
                    <svg v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                    >
                    <svg v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                    >
                    <svg v-if="service.type === 'AIRPORT_VIP_SERVICE'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                    >
                    <svg v-if="service.type === 'TRANSFER'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                    >
                    <svg v-if="service.type === 'FLIGHT'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                    >
                    <svg v-if="service.type === 'MAINLAND'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                    >
                    <svg v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                    >
                    <svg v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                    >
                    <svg v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                    >
                    <svg v-if="service.type === 'EXTRA_ACCOMMODATION'"
                         width="20px"
                         height="20px"
                         class="icon icon-categories">
                      <use
                          xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                    >
                    <span dir="auto">{{ service.name }}</span>
                  </div>
                  <div class="body__item-date invoice-shared__ltr-content">
                    <span>{{ parseDateToString(service.startDate) }} </span>
                    <span class="body__item-date__minus"> - </span>
                    <span>{{ parseDateToString(service.endDate) }}</span>
                  </div>
                  <div class="body__item-sub-title">
                    <div class="sub-title__block">
                      <span>{{ invoiceText('price') }}</span>
                    </div>
                    <div class="sub-title__block">
                      <span>{{ invoiceText('quantity') }}</span>
                    </div>
                    <div class="sub-title__block">
                      <span>{{ invoiceText('amount') }}</span>
                    </div>
                    <div class="sub-title__block">
                      <span>{{ invoiceText('toBePaid') }}</span>
                    </div>
                  </div>
                  <div class="body__item-sub-price">
                    <div class="sub-price__block first invoice-shared__ltr-content">
                      <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                      <span>{{ numberWithCommas(service.price) }}</span>
                    </div>
                    <div class="sub-price__block second invoice-shared__ltr-content">
                      <span>{{ service.quantity }}</span>
                    </div>
                    <div class="sub-price__block there invoice-shared__ltr-content">
                      <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                      <span>{{ numberWithCommas(service.amount) }}</span>
                    </div>
                    <div class="sub-price__block invoice-shared__ltr-content">
                      <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                      <span>{{ numberWithCommas(service.amountPayable) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payer__block">
                <div class="payer__total">
                  <div class="total-name">
                    <span>{{ invoiceText('currentDeposit') }}:</span>
                  </div>
                  <div class="total-line"></div>
                  <div class="total-result invoice-shared__ltr-content">
                    <template v-if="currentInvoice.currentDeposit">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.currentDeposit === null
                              ? ''
                              : numberWithCommas(currentInvoice.currentDeposit)
                        }}</span>
                    </template>
                    <template v-else>
                      <span>0</span>
                    </template>
                  </div>
                </div>
                <div class="payer__total">
                  <div class="total-name">
                    <span>{{ invoiceText('totalAmount') }}:</span>
                  </div>
                  <div class="total-line"></div>
                  <div class="total-result invoice-shared__ltr-content">
                    <template v-if="currentInvoice.totalAmount">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.totalAmount === null
                              ? ''
                              : numberWithCommas(currentInvoice.totalAmount)
                        }}</span>
                    </template>
                    <template v-else>
                      <span>0</span>
                    </template>
                  </div>
                </div>
                <div class="payer__total">
                  <div class="total-name">
                    <span>{{ invoiceText('amountPayable') }}:</span>
                  </div>
                  <div class="total-line"></div>
                  <div class="total-result invoice-shared__ltr-content">
                    <template v-if="currentInvoice.totalAmountPayable">
                      <span>{{
                          getCurrencySign(currentInvoice.currencyType)
                        }}
                        {{
                          currentInvoice.totalAmountPayable === null
                              ? ''
                              : numberWithCommas(currentInvoice.totalAmountPayable)
                        }}</span>
                    </template>
                    <template v-else>
                      <span>0</span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!--Mobile version end-->

            <div class="invoice-shared__alert invoice-shared__alert--emphasized">
              <svg width="20px" height="20px">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-invoice-alert-discount"></use>
              </svg>
              <span>{{ invoiceText('cardCommission') }}</span>
            </div>
            <div class="invoice-shared__descriptions">
              <div class="descriptions__block">
                <span>{{ invoiceText('bankCommissionNote') }}</span>
                <span>
                  {{ invoiceText('termsAcceptance') }}
                  <a
                      class="invoice-shared__ltr-content"
                      dir="ltr"
                      target="_blank"
                      href="https://altezzatravel.com/terms-and-conditions">https://altezzatravel.com/terms-and-conditions</a>
                </span>
              </div>
              <div class="descriptions__confirm">
                {{ invoiceText('amountPayableUpper') }}:
                  <template v-if="currentInvoice.totalAmountPayable">
                    <span class="invoice-shared__ltr-content">
                      {{getCurrencySign(currentInvoice.currencyType)}}
                      {{currentInvoice.totalAmountPayable === null ? '': numberWithCommas(currentInvoice.totalAmountPayable)}}
                    </span>
                  </template>
                  <span v-else class="invoice-shared__ltr-content">0</span>
                  {{ invoiceText('shouldBePaidBefore') }}
                  <span v-if="currentInvoice.deadline" class="invoice-shared__ltr-content">
                    {{
                      currentInvoice.deadline === null
                        ? ''
                        : parseDateToString(currentInvoice.deadline)
                    }}
                  </span>
                  <template v-else>({{ invoiceText('selectDate') }})</template>
                  {{ invoiceText('toConfirmBooking') }}

              </div>
            </div>
            <div class="invoice-shared__btn">
              <div class=""></div>
              <div class="btn-block">
                <button class="btn btn--orange" @click="printInvoice">
                  <svg
                      width="1em"
                      height="1em"
                      class="icon icon-chevron">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#print-w"></use>
                  </svg>
                  <span>{{ invoiceText('printInvoice') }}</span>
                </button>
                <button
                  v-if="currentInvoice.allowStripe"
                  class="invoice-payment-btn invoice-payment-btn--card"
                  @click="payInvoiceViaStripe(currentInvoice)"
                  :disabled="currentInvoice.status === 'PAID' || currentInvoice.status === 'PARTIALLY' || currentInvoice.status === 'CANCEL' || currentInvoice.status === 'REFUND'">
                  <img class="invoice-payment-btn__icon" :src="paymentButtonIcons.card" :alt="invoiceText('payByCardIcon')">
                  <span class="invoice-payment-btn__content">
                    <span class="invoice-payment-btn__title">{{ invoiceText('payByCard') }}</span>
                    <span class="invoice-payment-btn__subtitle">{{ invoiceText('cardFees') }}</span>
                  </span>
                </button>
                <button
                  class="invoice-payment-btn invoice-payment-btn--crypto"
                  @click="payInvoiceViaTriplea(currentInvoice)"
                  :disabled="currentInvoice.status === 'PAID' || currentInvoice.status === 'PARTIALLY' || currentInvoice.status === 'CANCEL' || currentInvoice.status === 'REFUND'">
                  <img class="invoice-payment-btn__icon" :src="paymentButtonIcons.crypto" :alt="invoiceText('payWithCryptoIcon')">
                  <span class="invoice-payment-btn__content">
                    <span class="invoice-payment-btn__title">{{ invoiceText('payWithCrypto') }}</span>
                    <span class="invoice-payment-btn__subtitle">{{ invoiceText('approximateCryptoFee') }}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="modal-wrapper" v-if="isModalCopy">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-link edit-popup--copy-link__invoice-shared">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-link">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link"></use>
                </svg>
              </div>
              <span>{{ invoiceText('textCopied') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isModalSuccess" class="modal-wrapper">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" style="align-items: flex-start;">
        <div class="edit-popup edit-popup--invoice-total-amount">
          <div  class="result-card">
            <div class="title">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" fill="#77B017"/>
                <path d="M13.595 19.8266C13.4805 19.9379 13.3242 20 13.1619 20C12.9995 20 12.8432 19.9379 12.7287 19.8266L9.26926 16.4847C8.91025 16.1379 8.91025 15.5756 9.26926 15.2295L9.70243 14.811C10.0616 14.4642 10.643 14.4642 11.0021 14.811L13.1619 16.8972L18.9979 11.2601C19.3571 10.9133 19.9391 10.9133 20.2976 11.2601L20.7307 11.6786C21.0898 12.0253 21.0898 12.5875 20.7307 12.9338L13.595 19.8266Z" fill="white"/>
                <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
              </svg>
              <span>{{ invoiceText('successfulPayment') }}</span>
            </div>
            <div class="desc">
              <span>{{ invoiceText('paymentThankYou') }}</span>
            </div>
            <div class="btn">
              <div @click="isModalSuccess = false" class="btn btn--green">
                <span>{{ invoiceText('thankYou') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import ATLoader from '@/components/Loaders/Loader'
import {API} from "@/utilites/api";
import paymentCardIcon from '@/assets/invoice-card-icon.svg'
import paymentCryptoIcon from '@/assets/invoice-crypto-icon.svg'
import {
  actionTypes as actionTypesInvoice,
  getterTypes as getterTypesInvoice,
} from '@/store/modules/invoices'
import {format, parse} from "date-fns";
import arSA from 'date-fns/locale/ar-SA'
import {getCurrencySign} from '@/common/helpers/currency'
export default {
  name: 'AtInvoiceShared',
  data() {
    return {
      isModalCopy: false,
      isModalSuccess: false,
      currentInvoiceBank: null,
      currentInvoicePayer: '',
      currentInvoice: null,
      invoiceRequestId: 0,
      isInvoice: true,
      API: API,
      paymentButtonIcons: {
        card: paymentCardIcon,
        crypto: paymentCryptoIcon
      }
    }
  },
  components: {ATLoader},
  computed: {
    ...Vuex.mapGetters({
      isLoadingInvoiceShared: getterTypesInvoice.isLoadingInvoiceShared,
      paymentInvoice: getterTypesInvoice.paymentInvoice,
      isLoadingPaymentInvoice: getterTypesInvoice.isLoadingPaymentInvoice,
      paymentLink: getterTypesInvoice.paymentLink
    }),
    invoiceLanguage() {
      return this.$route.query.lang === 'AR' ? 'AR' : 'EN'
    },
    isArabicInvoice() {
      return this.invoiceLanguage === 'AR'
    },
    invoiceLocale() {
      return this.isArabicInvoice ? 'ar' : 'en'
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.link !== from.params.link || (to.query.lang === 'AR') !== (from.query.lang === 'AR')) {
        if (to.params.link) this.findInvoiceShared(to.params.link)
      }
    },
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      getInvoiceShared: actionTypesInvoice.getInvoiceShared,
      sendStripePaymentInvoice: actionTypesInvoice.sendStripePaymentInvoice,
      sendTripleaPaymentInvoice: actionTypesInvoice.sendTripleaPaymentInvoice,
    }),
    invoiceText(key) {
      return this.$t(`invoiceShared.${key}`, this.invoiceLocale)
    },
    finishInvoiceLoading() {
      this.isInvoice = false
      document.title = this.$t(
          'invoiceShared.documentTitle',
          this.invoiceLocale,
          {number: this.currentInvoice.invoiceNumber}
      )
    },
    printInvoice() {
      window.print()
    },
    copyText(text){
      this.$clipboard(text)
      this.isModalCopy = true

      setTimeout(() => {
        this.isModalCopy = false
      }, 1000)
    },
    payInvoiceViaStripe(invoice) {
      this.sendStripePaymentInvoice({
        invoiceId: invoice.id,
        successUrl: `${location.origin}/invoice/shared/${invoice.link}?payment=success&lang=${this.invoiceLanguage}`,
        cancelUrl: `${location.origin}/invoice/payment/result/${invoice.link}?payment=failure`,
      }).then(() => window.location.href = this.paymentLink)
    },
    payInvoiceViaTriplea(invoice) {
      this.sendTripleaPaymentInvoice({
        invoiceId: invoice.id,
        successUrl: `${location.origin}/invoice/shared/${invoice.link}?payment=success&lang=${this.invoiceLanguage}`,
        cancelUrl: `${location.origin}/invoice/payment/result/${invoice.link}?payment=failure`,
      }).then(() => window.location.href = this.paymentLink)
    },
    findInvoiceShared(link) {
      const requestId = ++this.invoiceRequestId
      const lang = this.invoiceLanguage
      this.isInvoice = true
      this.getInvoiceShared({
        link: link,
        lang,
      }).then((res) => {
        if (requestId !== this.invoiceRequestId) return
        this.currentInvoice = res.data
        this.currentInvoiceBank = res.data.bank || null
        this.finishInvoiceLoading()
      })
    },
    parseDateToString(date) {
      if (!date) return
      return format(
          parse(date, 'dd.MM.yyyy', new Date()),
          'dd MMM yyyy',
          this.isArabicInvoice ? {locale: arSA} : undefined
      )
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  mounted() {
    if (this.$route.query.payment === 'success') this.isModalSuccess = true
    if (this.$route.params.link) this.findInvoiceShared(this.$route.params.link)
  },
}
</script>

<style lang="scss" scoped>
.invoice-shared__ltr-content {
  direction: ltr;
  unicode-bidi: isolate;
}

.invoice-shared__wrapper--rtl {
  font-family: Arial, Tahoma, sans-serif;
  text-align: right;

  .invoice-shared__top {
    .status {
      width: auto !important;
      min-width: 124px;

      .name,
      .circle,
      svg {
        margin-right: 0;
        margin-left: 8px;
      }
    }
  }

  .invoice-shared__bank {
    .content-block {
      &_desc {
        padding-left: 0;
        padding-right: 5px;
      }

      &_name {
        .sub-name {
          padding-left: 0;
          padding-right: 5px;
        }

        svg {
          border-left: 0;
          border-right: 1px solid #eaeaea;
          padding-left: 0;
          padding-right: 15px;
        }
      }
    }
  }

  .invoice-shared__payer {
    .payer-services-header {
      .services-header_title span {
        padding-left: 0;
        padding-right: 10px;
      }
    }

    .payer-services-body {
      .body__item-description {
        padding-right: 10px;
        padding-left: 0;
        border-right: 1px solid #E4E4E4;
        border-left: 0;

        svg {
          margin-right: 0;
          margin-left: 5px;
        }
      }

      .body__item-qty,
      .body__item-price,
      .body__item-date,
      .body__item-amount {
        border-right: 1px solid #E4E4E4;
        border-left: 0;
      }
    }
  }

  .payer__total {
    .total-name {
      padding: 5px 0 4px 5px;
    }

    .total-result span {
      padding: 5px 5px 4px 0;
      text-align: left;
    }
  }

  .invoice-shared__payer-mobile {
    .payer-mobile__services-header span {
      padding-left: 0;
      padding-right: 25px;
    }

    .payer-mobile__services-body {
      .body__item-description {
        padding-right: 10px;
        padding-left: 0;

        svg {
          margin-right: 0;
          margin-left: 5px;
        }
      }

      .body__item-sub-price .sub-price__block {
        &.first,
        &.second,
        &.there {
          border-right: 0;
          border-left: 1px solid #E4E4E4;
        }
      }
    }
  }

  .invoice-payment-btn__content {
    align-items: flex-start;
  }

  .modal-wrapper .result-card .title span {
    padding-left: 0;
    padding-right: 10px;
  }
}

.invoice-shared__btn {
  .btn-block {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
}

.invoice-payment-btn {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 18px 8px 16px;
  position: relative;
  min-height: 46px;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;

  &:not(:disabled):hover {
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  }

  &:not(:disabled):active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }

  &__icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  &__title,
  &__subtitle {
    display: block;
    width: 100%;
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: 0.01em;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  &__subtitle {
    font-size: 11px;
    font-weight: 500;
    line-height: 1.15;
  }

  &--card {
    background: #7bb80d;

    .invoice-payment-btn__title {
      background-image: linear-gradient(180deg, #ffffff 0%, #eef8cb 100%);
    }

    .invoice-payment-btn__subtitle {
      color: #c8dfa1;
      -webkit-text-fill-color: #c8dfa1;
      background: none;
    }

    &:not(:disabled):hover {
      background: #73af09;
    }
  }

  &--crypto {
    background: #060606;

    .invoice-payment-btn__title {
      background-image: linear-gradient(90deg, #f5ebff 0%, #9f63ff 100%);
    }

    .invoice-payment-btn__subtitle {
      color: #d9b2ff;
      -webkit-text-fill-color: #d9b2ff;
      background: none;
    }

    &:not(:disabled):hover {
      background: #311653;
    }
  }
}

.modal-wrapper {
  .modal-inner {
    padding: 25rem;
    .result-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        display: flex;
        align-items: center;

        padding-bottom: 20px;
        span {
          padding-left: 10px;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          text-align: center;

          color: #0C0C0C;
        }
      }
      .desc {
        text-align: center;

        padding-bottom: 20px;
        span {
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          text-align: center;

          color: #0C0C0C;
        }
      }
    }
  }
}
</style>
